'use client'

import { useEffect } from 'react'

export function ServiceWorkerRegister() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.register('/sw.js').catch(() => {
        // SW registration failed — non-critical
      })
    } else {
      // En dev: desregistrar cualquier SW para no servir chunks viejos cacheados
      // (causaba "module factory is not available" tras editar código)
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => {})
    }
  }, [])

  return null
}
